import { z } from "zod";

export const UserConfigFormDataSchema = z.object({
  pictureRequestPastDays: z
    .number({ invalid_type_error: "経過日数を0日以上で入力してください" })
    .min(0, "経過日数は0日以上で入力してください")
    .max(1000, "経過日数は1000日以内で入力してください"),
  mapInitLat: z.number(),
  mapInitLon: z.number(),
});

// 定義したZodのスキーマをTypescriptの型に変換
export type UserConfigFormData = z.infer<typeof UserConfigFormDataSchema>;

export const ChangePasswordFormSchema = z
  .object({
    currentPassword: z
      .string()
      .min(8, "パスワードは8文字以上で入力してください"),
    newPassword: z
      .string()
      .min(8, "パスワードは8文字以上で入力してください")
      .superRefine((val, ctx) => {
        if (/^\d+$/.test(val)) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: "パスワードには数字以外も含めてください",
          });
        }
      }),
    newPasswordConfirmation: z.string(),
  })
  .superRefine((data, ctx) => {
    if (data.newPassword !== data.newPasswordConfirmation) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "パスワードが一致しません",
        path: ["newPasswordConfirmation"],
      });
    }
  });

export type ChangePasswordFormData = z.infer<typeof ChangePasswordFormSchema>;
